import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface TrackingRequest {
    getPage: number;
    getPageSize: number;
    bl_no?: string;
    o_kind?: string;
    s_a_name?: string;
    s_b_contact?: string;
    s_date?: string;
    e_date?: string;
    s_kind?: string;
    s_p_dept?: string;
    pay_kind?: string; // 지불구분 (요약 숫자 클릭 필터)
    exclude_cancel?: string; // 'Y' 이면 접수취소 제외 (요약 숫자 클릭 필터)
}

interface TrackingOrder {
    num: number;
    idx: string;
    bl_no: string;
    o_kind: string;
    w_date: string;
    et_name: string;
    s_c_contact: string;
    s_b_contact: string;
    c_code: string;
    s_kind: string;
    o_date: string;
    modifyAddButton: string[];
    cancelDate: string;
    memo: string | null;
    memoButton: boolean;
    chk_bl_no: string[];
    a_request: string;
}

interface Dept {
    sn: number;
    dept_name: string;
}

export interface TrackingSummaryPay {
    pay_code: string;
    pay_name: string;
    count: number;
    cancel_count: number;
    qty: number;
}

export interface TrackingSummary {
    accept_count: number; // 접수
    cancel_count: number; // 취소
    net_count: number; // 총접수 (접수 - 취소)
    total_qty: number; // 총수량 (접수취소 제외)
    payList: TrackingSummaryPay[];
}

export interface TrackingResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    summary?: TrackingSummary;
    orderList: TrackingOrder[];
    dept: Dept[];
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePostTrackingList = (
    accessToken?: string | null,
    successCallback?: (data: TrackingResponse) => void,
): UseMutationResult<TrackingResponse, AxiosError<ApiErrorResponse>, TrackingRequest> => {
    return useMutation<TrackingResponse, AxiosError<ApiErrorResponse>, TrackingRequest>({
        mutationFn: async requestData => {
            // 요청 시점에 store에서 최신 토큰을 가져오기
            // const accessToken = useMorningAuthStore.getState().accessToken;

            // if (!accessToken) {
            //     // 토큰 없으면 그냥 요청 중단
            //     return Promise.resolve(undefined as unknown as TrackingResponse);
            // }

            const response = await axios.post(
                enum_api_uri.tracking_list,
                requestData,
                accessToken
                    ? {
                          headers: {
                              Authorization: `Bearer ${accessToken}`,
                              "Content-Type": "application/json",
                          },
                      }
                    : {},
            );
            return response.data.data;
        },
        onSuccess: data => {
            successCallback?.(data);
        },
    });
};
